import React, { useEffect } from 'react';
import './Menu.css';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveMenuItem } from '../../store/menuSlice.js'; // Importujemy akcję do aktualizacji aktywnego linku
import { clearTokens } from '../../store/tokensSlice.js';
import MenuButton from './menuButton.jsx';

import { ReactComponent as People } from '../icons/people.svg';
import { ReactComponent as StatusUp } from '../icons/status-up.svg';
import { ReactComponent as TasskSquare } from '../icons/task-square.svg';
import { ReactComponent as Cup } from '../icons/cup.svg';
import { ReactComponent as Trainings } from '../icons/vid-oct.svg';
import { ReactComponent as Teacher } from '../icons/teacher.svg';
import { ReactComponent as DingDong } from '../icons/ding-dong.svg';
import { ReactComponent as Star } from '../icons/star.svg';
import { ReactComponent as Award } from '../icons/award.svg';
import { ReactComponent as Logout } from '../icons/logout.svg';
import { ReactComponent as Settings } from '../icons/settings.svg';
import { ReactComponent as UserSquare } from '../icons/user-square.svg';
import { ReactComponent as TeamMeLogo } from '../icons/full_logo.svg';
import { ReactComponent as DocumentsIcon } from '../icons/task-square.svg';
import { ReactComponent as EncyclopediaIcon } from '../icons/teacher.svg';

import { useLocation } from 'react-router-dom';

function Menu() {
  const location = useLocation();
  const activeLink = useSelector((state) => state.menu.activeMenuItem); // Pobranie aktywnego linku z Redux  
  const dispatch = useDispatch();

  const handleLinkClick = (path) => {
    dispatch(setActiveMenuItem(path)); // Aktualizacja aktywnego linku w Redux
  };

   // Wywołanie handleLinkClick przy pierwszym ładowaniu
   useEffect(() => {
    handleLinkClick(location.pathname); // Wywołanie funkcji z aktualną ścieżką
  }, [location.pathname]); // Uruchomienie efektu, gdy zmieni się ścieżka

  const handleLogoutClick = (path) => {
    dispatch(clearTokens()); // Ustawienie tokenu dostępu na pusty
    window.location.reload(); // Odświeżenie strony po wylogowaniu
  };

  const menuItems = [
    { path: '/', icon: People, label: 'Użytkownicy' , text:'Użytkownicy'},
    { path: '/encyclopedia', icon: EncyclopediaIcon, label: 'Wiedza' , text:'Wiedza'},
    { path: '/documents', icon: DocumentsIcon, label: 'Dokumenty' , text:'Dokumenty'},
    { path: '/statistics', icon: StatusUp, label: 'Statystyki', text: 'Statystyki' },
    { path: '/notifications', icon: DingDong, label: 'Notyfikacje' , text:'Notyfikacje'},
   // { path: '/sports', icon: Cup, label: 'Dyscypliny' },
    //{ path: '/trainings', icon: Trainings, label: 'Treningi' },
   // { path: '/opinions', icon: Star, label: 'Opinie' },
    //{ path: '/faq', icon: Teacher, label: 'FAQ' },
    // { path: '/awards', icon: Award, label: 'Prawdopodobny kolejny' },
  ];
  return (
    <div className="menu">
      <div className="menu-content">
        {/* Logo po lewej stronie */}
        <div className="menu-logo">
          <TeamMeLogo className="menu-icon-without-text" />
        </div>

        {/* Środkowy div z wyśrodkowanymi dziećmi */}
        <div className="menu-center">
          {menuItems.map((item) => (
            <MenuButton
              key={item.path}
              path={item.path}
              currentPath={activeLink}
              onClick={handleLinkClick}
              icon={item.icon}
              label={item.label}
              buttonText={item.text}
              showLabel={false}
              showSpeechBubble={true}
            />
          ))}
        </div>

        {/* Prawy div */}
        <div className="menu-right">
          <MenuButton
            path="/settings"
            currentPath={activeLink}
            onClick={handleLinkClick}
            icon={Settings}
            label=""
            afterClickingChange={false}
          />
          <MenuButton
            path="/profile"
            currentPath={activeLink}
            onClick={handleLinkClick}
            icon={UserSquare}
            label=""
            afterClickingChange={false}
          />
            <span className="menu-divider" aria-hidden="true"></span>

            <MenuButton
            path="/logout"
            currentPath={activeLink}
            onClick={handleLogoutClick}
            icon={Logout}
            label="Wyloguj się"
            iconfirst={false}
            afterClickingChange={false}
            //borders="L" // Przykład użycia ramek (L - lewa, R - prawa, B - dolna, T - górna)
          />
        </div>
      </div>
    </div>
  );
}

export default Menu;